import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal, Accordion, Image } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { importExportTableCustomStyles } from "../utils/TableCustomStyles";
import "../components/css/StepperForm.css";
import "../components/css/ToolTipForm.css";
import Select from "react-select";
import InoxLogo from '../images/inox_logo.png';
import ContainerImage from "../images/container.png";
import IsoTankImage from "../images/iso_tank.png";
import { FormatCurrency } from "../utils/FormatCurrency";


function Quote() {
  const requestFormRef = useRef(null);
  const [tarrifChargeDataPending, setTarrifChargeDataPending] = useState(false);
  const [enableSearchButton, setEnableSearchButton] = useState(false);
  const [portList, setPortList] = useState([]);
  const [containerSizeList, setContainerSizeList] = useState([]);
  const [cargoTypeList, setCargoTypeList] = useState([
                                            {"value": "HAZARDOUS", "label":"HAZARDOUS"},
                                            {"value": "NON_HAZARDOUS", "label":"NON_HAZARDOUS"},
                                            {"value": "EMPTY", "label":"EMPTY"}
                                            ]);
                                          
  const [commodityList, setCommodityList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);  
  const [vesselScheduleList, setVesselScheduleList] = useState(false);  
  const [showQuoteRequestLoader, setShowQuoteRequestLoader] = useState(false);  
  const [selectedVesselSchedule, setSelectedVesselSchedule] = useState(false);  
  const [icdExportCurrency, setIcdExportCurrency] = useState("");
  const [icdImportCurrency, setIcdImportCurrency] = useState("");
  const [ihcExportRoute, setIhcExportRoute] = useState("");
  const [ihcImportRoute, setIhcImportRoute] = useState("");
  const [totalExportCharge, setTotalExportCharge] = useState(0);
  const [totalImportCharge, setTotalImportCharge] = useState(0);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [requestName, setRequestName] = useState("");
  const [requestEmail, setRequestEmail] = useState("");
  const [requestContact, setRequestContact] = useState("");
   
                                                  
  // ----------- Add State Variables
  const [selectedPoa, setSelectedPoa] = useState("");
  const [selectedPol, setSelectedPol] = useState("");
  const [selectedPolTerminal, setSelectedPolTerminal] = useState("");
  const [selectedPod, setSelectedPod] = useState("");
  const [selectedFd, setSelectedFd] = useState("");
  const [importLocal, setImportLocal] = useState([]);
  const [exportLocal, setExportLocal] = useState([]);
  const [remarks, setRemarks] = useState("");


  // ----------- Update State Variables
  const [bookingLineItemLoader, setBookingLineItemLoader] = useState(false);
  const [showRouteError, setShowRouteError] = useState(false);
  const [routeFormOpen, setRouteFormOpen] = useState(false);
  const [cargoFormOpen, setCargoFormOpen] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const triggerRouteFormRef = useRef(null);
  const triggerCargoFormRef = useRef(null);
  const tooltipRouteFormRef = useRef(null);
  const tooltipCargoFormRef = useRef(null);  

  const generateId = () => Date.now() + Math.random();

  // =========================================== Cargo Rows ============================================
  const [cargoRows, setCargoRows] = useState([
    {
      id: generateId,
      container_size: "",
      quantity: 1,
      weight: 0,
      tare_weight: 0,
      slot: 0,
      export_iso_tank_charge: 0,
      export_dg_surcharge: 0,
      export_bss_surcharge: 0,
      export_transport_charge: 0,
      export_iso_tank_charge_expense: 0,
      export_dg_surcharge_expense: 0,
      export_bss_surcharge_expense: 0,
      export_transport_charge_expense: 0,
      import_iso_tank_charge: 0,
      import_dg_surcharge: 0,
      import_bss_surcharge: 0,
      import_transport_charge: 0,
      import_iso_tank_charge_expense: 0,
      import_dg_surcharge_expense: 0,
      import_bss_surcharge_expense: 0,
      import_transport_charge_expense: 0,
      cargo_type: "",
      commodity: "",
      currency: ""
    },
  ]);

  const addRow = () => {
    setCargoRows([
      ...cargoRows,
      {
        id: generateId,
        container_size: "",
        quantity: 1,
        weight: 0,
        tare_weight: 0,
        slot: 0,
        export_iso_tank_charge: 0,
        export_dg_surcharge: 0,
        export_bss_surcharge: 0,
        export_transport_charge: 0,
        export_iso_tank_charge_expense: 0,
        export_dg_surcharge_expense: 0,
        export_bss_surcharge_expense: 0,
        export_transport_charge_expense: 0,
        import_iso_tank_charge: 0,
        import_dg_surcharge: 0,
        import_bss_surcharge: 0,
        import_transport_charge: 0,
        import_iso_tank_charge_expense: 0,
        import_dg_surcharge_expense: 0,
        import_bss_surcharge_expense: 0,
        import_transport_charge_expense: 0,
        cargo_type: "",
        commodity: "",
        currency: ""
      },
    ]);
  };

  const removeRow = (id) => {
    setCargoRows(cargoRows.filter((row) => row.id !== id));
  };

  const handleChange = (index, id, field, value) => {
    if(field == "cargo_type"){
      getCommodity()
      setCommodityList(commodityList.filter(item => item.type == value))
    }
    cargoRows[index][field] = value;
    setCargoRows(cargoRows);
  };

  const refreshRows = () => {
    addRow()
    setCargoRows(cargoRows => cargoRows.slice(0, -1))
  }

  // ============================================= IHC Export =============================================

  const getIhcExportRoute = async(icd, pol) => {
    const icd_port = icd?.value
    const icd_port_type = icd?.type
    const pol_port = pol?.value

    if(icd_port != undefined && icd_port_type == "DRYPORT"){
      if(pol_port != undefined){
        try {
              const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulageroute?icd='+icd_port+'&via_port='+pol_port);
              const id = response.data?.[0]?.id
              setIhcExportRoute(id)

              const icd_origin_currency = response.data?.[0]?.icd_data?.currency_data
              const icd_export_currency = {"country": icd_origin_currency?.country_data?.long_name, "currency_value":  icd_origin_currency?.current_value, "symbol":  icd_origin_currency?.symbol}
              setIcdExportCurrency(icd_export_currency)
            } 
        catch (err) {
              toast.error("Error in fetching IHC Charges data! Try again.");
        }
      }
    }
  }

  const getIhcExportCharge = async(row, index) => {
    const container_type = row['container_size']?.['value']
    const container_carrier_type = row['container_size']?.['type']
    const cargo_type = row['cargo_type']
    const quantity = row['quantity']
    const weight = row['weight']

    if(container_type != ""){
      if(cargo_type != ""){
        if(weight != 0){
          try {
              const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulagecharge?route='+ihcExportRoute+'&product='+container_type);
              const ihc_charge_data = response.data

              const ihc_charge_ranges = ihc_charge_data.filter(charge => charge.min_weight <= (parseFloat(weight) + parseFloat(charge.tare_weight))  
                                                                        && charge.max_weight >= (parseFloat(weight) + parseFloat(charge.tare_weight)));
              const ihc_charge = ihc_charge_ranges[0]?.charge
              const tare_weight = ihc_charge_ranges[0]?.tare_weight
              const export_iso_tank_charge = container_carrier_type == "TANK"? parseFloat(ihc_charge) * parseFloat(quantity) * 0.2: 0
              const export_dg_surcharge = cargo_type == "HAZARDOUS" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.25: 0
              const export_bss_surcharge = parseFloat(ihc_charge) * parseFloat(quantity) * 0.10

              const ihc_expense = ihc_charge_ranges[0]?.expense
              const export_iso_tank_charge_expense = container_carrier_type == "TANK"? parseFloat(ihc_expense) * parseFloat(quantity) * 0.2: 0
              const export_dg_surcharge_expense = cargo_type == "HAZARDOUS" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.25: 0
              const export_bss_surcharge_expense = parseFloat(ihc_expense) * parseFloat(quantity) * 0.10

              cargoRows[index].tare_weight = tare_weight
              cargoRows[index].export_iso_tank_charge = export_iso_tank_charge
              cargoRows[index].export_iso_tank_charge_expense = export_iso_tank_charge_expense

              cargoRows[index].export_dg_surcharge = export_dg_surcharge
              cargoRows[index].export_dg_surcharge_expense = export_dg_surcharge_expense
              
              cargoRows[index].export_bss_surcharge = export_bss_surcharge
              cargoRows[index].export_bss_surcharge_expense = export_bss_surcharge_expense

              cargoRows[index].export_transport_charge = parseFloat(ihc_charge) * parseFloat(quantity)
              cargoRows[index].export_transport_charge_expense = parseFloat(ihc_expense) * parseFloat(quantity)

              setCargoRows(cargoRows)
              refreshRows()
            } catch (err) {
              toast.error("Error in fetching IHC Export Charges data! Try again.");
            }
        }
      }
    }
  }

  // ============================================= IHC Import =============================================
  
  const getIhcImportRoute = async(pod, icd) => {
    const pod_port = pod?.value
    const icd_port = icd?.value
    const icd_port_type = icd?.type

    if(icd_port != undefined && icd_port_type == "DRYPORT"){
      if(pod_port != undefined){
        try {
              const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulageroute?icd='+icd_port+'&via_port='+pod_port);
              const id = response.data?.[0]?.id
              setIhcImportRoute(id)

              const icd_origin_currency = response.data?.[0]?.icd_data?.currency_data
              console.log("icd_origin_currency", icd_origin_currency)
              const icd_import_currency = {"country": icd_origin_currency?.country_data?.long_name, "currency_value":  icd_origin_currency?.current_value, "symbol":  icd_origin_currency?.symbol}
              console.log("icd_import_currency", icd_import_currency)
              setIcdImportCurrency(icd_import_currency)
            } 
        catch (err) {
              toast.error("Error in fetching IHC Charges data! Try again.");
        }
      }
    }
  }

  const getIhcImportCharge = async(row, index) => {
    const container_type = row['container_size']?.['value']
    const container_carrier_type = row['container_size']?.['type']
    const cargo_type = row['cargo_type']
    const quantity = row['quantity']
    const weight = row['weight']

    if(container_type != ""){
      if(cargo_type != ""){
        if(weight != 0){
          try {
              const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/inlandhaulagecharge?route='+ihcImportRoute+'&product='+container_type);
              const ihc_charge_data = response.data

              const ihc_charge_ranges = ihc_charge_data.filter(charge => charge.min_weight <= (parseFloat(weight) + parseFloat(charge.tare_weight))  
                                                                        && charge.max_weight >= (parseFloat(weight) + parseFloat(charge.tare_weight)));
              const ihc_charge = ihc_charge_ranges[0]?.charge
              const tare_weight = ihc_charge_ranges[0]?.tare_weight
              const import_iso_tank_charge = container_carrier_type == "TANK"? parseFloat(ihc_charge) * parseFloat(quantity) * 0.2: 0
              const import_dg_surcharge = cargo_type == "HAZARDOUS" ? parseFloat(ihc_charge) * parseFloat(quantity) * 0.25: 0
              const import_bss_surcharge = parseFloat(ihc_charge) * parseFloat(quantity) * 0.10

              const ihc_expense = ihc_charge_ranges[0]?.expense
              const import_iso_tank_charge_expense = container_carrier_type == "TANK"? parseFloat(ihc_expense) * parseFloat(quantity) * 0.2: 0
              const import_dg_surcharge_expense = cargo_type == "HAZARDOUS" ? parseFloat(ihc_expense) * parseFloat(quantity) * 0.25: 0
              const import_bss_surcharge_expense = parseFloat(ihc_expense) * parseFloat(quantity) * 0.10

              cargoRows[index].tare_weight = tare_weight
              cargoRows[index].import_iso_tank_charge = import_iso_tank_charge
              cargoRows[index].import_iso_tank_charge_expense = import_iso_tank_charge_expense

              cargoRows[index].import_dg_surcharge = import_dg_surcharge
              cargoRows[index].import_dg_surcharge_expense = import_dg_surcharge_expense
              
              cargoRows[index].import_bss_surcharge = import_bss_surcharge
              cargoRows[index].import_bss_surcharge_expense = import_bss_surcharge_expense

              cargoRows[index].import_transport_charge = parseFloat(ihc_charge) * parseFloat(quantity)
              cargoRows[index].import_transport_charge_expense = parseFloat(ihc_expense) * parseFloat(quantity)

              setCargoRows(cargoRows)
              refreshRows()
            } catch (err) {
              toast.error("Error in fetching IHC Import Charges data! Try again.");
            }
        }
      }
    }
  }

  const getPort = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/port/');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name, type: item.type }));
        setPortList(data)
      }
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  }

  const getContainerSize = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/product?type=CONTAINER');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.product_name, type: item.type }));
        setContainerSizeList(data)
      }
    } catch (err) {
      toast.error("Error in fetching container size data! Try again.");
    }
  }

  const getCommodity = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/cargo');
      if (response) {
        const data = response.data.map(item => ({ value: item.name, label: item.name, type: item.cargo_type }));
        setCommodityList(data)
      }
    } catch (err) {
      toast.error("Error in fetching commodity data! Try again.");
    }
  }

  const getTariffCharges = async () => {
    try {
    setTarrifChargeDataPending(true)
    const container_type = cargoRows?.[0]?.container_size?.value
    const cargo_type = cargoRows?.[0]?.cargo_type

    const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/tariffcharge/gettariffcharges?tariff__poa='+selectedPoa?.value+'&tariff__pol='+selectedPol?.value+
                                  '&tariff__pol_terminal='+selectedPolTerminal+'&tariff__pod='+selectedPod?.value+'&tariff__fd='+selectedFd?.value+
                                  '&charge_type='+cargo_type+'&product='+container_type);

    if (response) {
        const importLocalCharges = response.data.filter(charge => charge.charge_category == "IMPORT_LOCAL").map(charge => ({
                                                                                                                            product_data: charge?.product_data,
                                                                                                                            product_name: charge?.product_data?.product_name,
                                                                                                                            charge_name: charge?.charge_name,
                                                                                                                            amount: charge?.amount,
                                                                                                                            expense: charge?.expense,
                                                                                                                            amount_type: charge?.amount_type || "", 
                                                                                                                            charge_basis: charge?.charge_basis || "",
                                                                                                                            currency_data: charge?.currency_data,
                                                                                                                            currency: charge?.currency_data?.symbol || "",
                                                                                                                            quantity: 1,
                                                                                                                            total: 0.0,
                                                                                                                            requested: 0.0,
                                                                                                                            approved: 0.0,
                                                                                                                            approved_by: ""
                                                                                                                        }));

        const exportLocalCharges = response.data.filter(charge => charge.charge_category == "EXPORT_LOCAL").map(charge => ({
                                                                                                                            product_data: charge?.product_data,
                                                                                                                            product_name: charge?.product_data?.product_name,
                                                                                                                            charge_name: charge?.charge_name,
                                                                                                                            amount: charge?.amount,
                                                                                                                            expense: charge?.expense,
                                                                                                                            amount_type: charge?.amount_type || "", 
                                                                                                                            charge_basis: charge?.charge_basis || "",
                                                                                                                            currency_data: charge?.currency_data,
                                                                                                                            currency: charge?.currency_data?.symbol || "",
                                                                                                                            quantity: 1,
                                                                                                                            total: 0.0,
                                                                                                                            requested: 0.0,
                                                                                                                            approved: 0.0,
                                                                                                                            approved_by: ""
                                                                                                                        }));

        // -------------- EXPORTS --------------------
        setExportLocal(exportLocalCharges)
        var total_export_charge = 0
        for(let i=0; i<exportLocalCharges.length;i++){
          if(exportLocalCharges[i]['amount_type'] == 'AMOUNT'){
            var currency_value = exportLocalCharges[i]?.['currency_data']?.['current_value'] ? exportLocalCharges[i]?.['currency_data']?.['current_value'] : 1
            total_export_charge += exportLocalCharges[i]['amount'] / currency_value
          }
        }
        
        setTotalExportCharge(total_export_charge)

        // -------------- IMPORTS --------------------
        getIhcImportRoute(selectedPod, selectedFd)

        for(let i=0; i<cargoRows.length;i++){
          const slot = {
                        product_data: {"product_name": cargoRows[i]?.container_size?.label},
                        product_name: cargoRows[i]?.container_size?.label,
                        charge_type: "Amount",
                        charge_name: "IHC Charge ("+cargoRows[i]?.weight * cargoRows[i]?.quantity+" MT + "+cargoRows[i]?.tare_weight * cargoRows[i]?.quantity+" Tare Wt)",
                        amount: (cargoRows[i]?.import_transport_charge + cargoRows[i]?.import_iso_tank_charge + cargoRows[i]?.import_bss_surcharge + cargoRows[i]?.import_dg_surcharge) / cargoRows[i]?.quantity,
                        expense: (cargoRows[i]?.import_transport_charge_expense + cargoRows[i]?.import_iso_tank_charge_expense + cargoRows[i]?.import_bss_surcharge_expense + cargoRows[i]?.import_dg_surcharge_expense) / cargoRows[i]?.quantity, 
                        amount_type: "AMOUNT", 
                        charge_basis: "PER_CONTAINER",
                        currency_data: {"current_value": parseFloat(icdImportCurrency?.currency_value), "symbol": icdImportCurrency?.symbol},
                        currency: cargoRows[i]?.currency,
                        quantity: cargoRows[i]?.quantity,
                        total: cargoRows[i]?.import_transport_charge_expense,
                        requested: 0.0,
                        approved: 0.0,
                        approved_by: ""
                      }

          importLocalCharges.push(slot)
        }

        setImportLocal(importLocalCharges)
        var total_import_charge = 0
        for(let i=0; i<importLocalCharges.length;i++){
          if(importLocalCharges[i]['amount_type'] == 'AMOUNT'){
            var currency_value = importLocalCharges[i]?.['currency_data']?.['current_value'] ? importLocalCharges[i]?.['currency_data']?.['current_value'] : 1
            total_import_charge += importLocalCharges[i]['amount'] / currency_value
          }
        }
        setTotalImportCharge(total_import_charge)
        
        setTarrifChargeDataPending(false)
    }
    } catch (err) {
    toast.error("Error in fetching operator data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/currency');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.symbol +" ("+item.name+")", }));
        setCurrencyList(data)
      }
    } catch (err) {
      toast.error("Error in fetching charge data! Try again.");
    }
  }

  const localchargescolumns = [
    {
      name: 'Product',
      selector: row => <span className={`${row.product_data == "Adhoc"?"bg-warning px-2 rounded":""}`}>{row.product_data == "Adhoc"? row.product_data: row.product_data?.product_name}</span>,
      sortable: true,
    },
    {
      name: 'Charge',
      selector: row => row.charge_name,
      width: "300px",
      sortable: true,
    },
    {
      name: 'Amount',
      selector: row => row.amount_type == 'PERCENTAGE'? row.amount + " %": row.amount + " x " + row.quantity,
      sortable: true,
    },
    {
      name: 'Total',
      selector: row => 
        <>
        <span>{row.product_data == "Adhoc"? row.currency?.label[0]: row.currency_data?.symbol}</span>
        <span> {row.amount_type == 'PERCENTAGE'? row.amount + " %": row.amount}</span>
        </>,
      sortable: true,
    }
  ];

  // ---------------------- Route Form ---------------------------
  const handleRouteFormClick = () => {
    const rect = triggerRouteFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });
    setRouteFormOpen(true);
  };

  useEffect(() => {
    function handleRouteFormOutsideClick(e) {
      if (
        tooltipRouteFormRef.current &&
        !tooltipRouteFormRef.current.contains(e.target) &&
        !triggerRouteFormRef.current.contains(e.target)
      ) {
        setRouteFormOpen(false);
        setShowRouteError(true);
      }
    }
    document.addEventListener("mousedown", handleRouteFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleRouteFormOutsideClick);
  }, []);

  // ---------------------- Cargo Form ---------------------------
  const handleCargoFormClick = () => {
    const rect = triggerCargoFormRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: rect.left + window.scrollX + rect.width / 3,
    });
    setCargoFormOpen(true);
    console.log("cargoRows", cargoRows)
    setCargoRows(cargoRows);
  };

  useEffect(() => {
    function handleCargoFormOutsideClick(e) {
      if (
        tooltipCargoFormRef.current &&
        !tooltipCargoFormRef.current.contains(e.target) &&
        !triggerCargoFormRef.current.contains(e.target)
      ) {
        setCargoFormOpen(false);
      }
    }
    document.addEventListener("mousedown", handleCargoFormOutsideClick);
    return () => document.removeEventListener("mousedown", handleCargoFormOutsideClick);
  }, []);


  useEffect(() => {
    getPort()
    getContainerSize()
    getCommodity()
    getCurrency()
  }, []);

  const customRouteValidationStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: !state.hasValue && showRouteError ? 'red' : base.borderColor,
      boxShadow: 'none',
      '&:hover': {
        borderColor: !state.hasValue && showRouteError ? 'red' : base.borderColor
      },
    }),
  };

  useEffect(() => {
    if(selectedPoa && selectedPol && selectedPod && selectedFd){
      setEnableSearchButton(true)
    }
    else{
      setEnableSearchButton(false)
    }
  }, [selectedPoa, selectedPol, selectedPod, selectedFd]);


  const addNewRequest = async (e) => {
    e.preventDefault();
    setShowQuoteRequestLoader(true)

    const data = {
      poa: selectedPoa?.value,
      pol: selectedPol?.value,
      pol_terminal: selectedPolTerminal,
      pod: selectedPod?.value,
      fd: selectedFd?.value,
      first_vessel_schedule: selectedVesselSchedule?.value,
      remarks: remarks,
      weight: cargoRows.reduce((sum, row) => sum + Number(row.weight || 0), 0),
      import_charge: importLocal,
      export_charge: exportLocal,
      total_import_local_amount: totalImportCharge,
      total_export_local_amount: totalExportCharge,
      status: "REQUEST",
      request_by_name: requestName,
      request_by_email: requestEmail,
      request_by_contact: requestContact,
      line_booking_item: cargoRows
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/bookingrequest/createbookingrequest/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status == 200 ) {
      setSelectedPoa("")
      setSelectedPol("")
      setSelectedPolTerminal("")
      setSelectedPod("")
      setSelectedFd("")
      setSelectedVesselSchedule("")
      setRemarks("")
      setImportLocal([])
      setExportLocal([])
      setTotalImportCharge(0)
      setTotalExportCharge(0)
      setRequestName("")
      setRequestEmail("")
      setRequestContact("")
      setCargoRows([{
                      id: generateId,
                      container_size: "",
                      quantity: 1,
                      weight: 0,
                      tare_weight: 0,
                      slot: 0,
                      export_iso_tank_charge: 0,
                      export_dg_surcharge: 0,
                      export_bss_surcharge: 0,
                      export_transport_charge: 0,
                      export_iso_tank_charge_expense: 0,
                      export_dg_surcharge_expense: 0,
                      export_bss_surcharge_expense: 0,
                      export_transport_charge_expense: 0,
                      import_iso_tank_charge: 0,
                      import_dg_surcharge: 0,
                      import_bss_surcharge: 0,
                      import_transport_charge: 0,
                      import_iso_tank_charge_expense: 0,
                      import_dg_surcharge_expense: 0,
                      import_bss_surcharge_expense: 0,
                      import_transport_charge_expense: 0,
                      cargo_type: "",
                      commodity: "",
                      currency: ""
                    }])
      toast.success("Request Sent Successfully")
    }
    setShowQuoteRequestLoader(false)
    setShowRequestModal(false)
  }

  const getVesselSchedule = async (pickup_port, destination_port) => {
      try {
        if(pickup_port.value != undefined && destination_port.value != undefined){
          const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule?pick_port='+pickup_port.value+'&next_port='+destination_port.value);
          if (response) {
            const data = response.data.map(item => ({ value: item.id, label: item.vessel_data.name +" at "+item.pick_port_data?.name+" - "+item.pick_terminal_data?.name+" (" + item.eta_date +") ", terminal: item?.pick_terminal_data?.id}));
            setVesselScheduleList(data)
          }
        }
      } catch (err) {
        toast.error("Error in fetching vessel schedule data! Try again.");
      }
    }

  return (
    <div className="page-content-bg quote-page">
      <ToastContainer></ToastContainer>
    
      <div className="row mx-3 text-left py-0" >
        <div className="col-12">
          <div className="row">
            <div className="col-2">
                <Image src={InoxLogo} className="mt-2 mx-2" alt="Logo" style={{ width: 120 }} height={60} />
            </div>
            <div className="col-8">
                <h1 className="text-center text-inox-green fw-bold mt-3">Get a Quote</h1>
            </div>
            <div className="col-2">
                
            </div>
          </div>

          <div className="row" style={{ marginRight: 35 }}>
            <div class="col-12 border rounded shadow mt-3" style={{ marginLeft: 18 }}>
              <div className="d-flex my-3">
                <div class="p-2 flex-grow-1">
                  <h5 className="fw-bold">Route</h5>
                  <input 
                    ref={triggerRouteFormRef} 
                    type="text" 
                    className="form-control form-control-sm border-0" 
                    placeholder="Shipping From and To" 
                    onClick={handleRouteFormClick}
                  />
                  
                  {selectedPoa && selectedPol && selectedPod && selectedFd && selectedVesselSchedule?
                    <div className="bg-whhite pt-3" style={{ fontSize: 12 }}>
                      <span><b>POA: </b> {selectedPoa.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                      <span><b>POL: </b> {selectedPol.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                      <span><b>POD: </b> {selectedPod.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                      <span><b>FD: </b> {selectedFd.label ?? <span className="text-danger fw-bold">None</span>}</span><br></br>
                      <span><b>Vessel: </b> {selectedVesselSchedule?.label ?? <span className="text-danger fw-bold">None</span>}</span>
                    </div>
                    :""
                  }

                  {routeFormOpen && (
                    <div
                      ref={tooltipRouteFormRef}
                      className="tooltip-form-container"
                      style={{
                        top: tooltipPosition.top,
                        left: tooltipPosition.left,
                        transform: "translateX(-35%)",
                      }}
                    >
                      <div className="tooltip-arrow" />
                        <div className="tooltip-content px-3" style={{background: '#FFF' }}>
                          <form className="tooltip-form">
                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">POA</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={portList} 
                                  id="poa" 
                                  name="poa" 
                                  onChange={(e) => [
                                                    setSelectedPoa(e),
                                                    getIhcExportRoute(e, selectedPol)
                                                  ]}
                                  value={selectedPoa}
                                  isMulti={false}
                                  isClearable
                                  className="px-0"
                                  placeholder={<span>POA <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">POL</div>

                              <div className="col-12 px-0">
                                <Select 
                                  options={portList} 
                                  id="pol" 
                                  name="pol" 
                                  onChange={(e) => [
                                                    setSelectedPol(e), 
                                                    getVesselSchedule(e, selectedPod),
                                                    getIhcExportRoute(selectedPoa, e)
                                                  ]}
                                  value={selectedPol}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 flex-grow-1 mr-1"
                                  placeholder={<span>POL <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                />
                              </div>
                            </div>
                            
                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">POD</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={portList} 
                                  id="pod" 
                                  name="pod" 
                                  onChange={(e) => [
                                                    setSelectedPod(e), 
                                                    getVesselSchedule(selectedPol, e),
                                                    getIhcImportRoute(e, selectedFd)
                                                  ]}
                                  value={selectedPod}
                                  isMulti={false}
                                  isClearable
                                  className="px-0"
                                  placeholder={<span>POD <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">FD</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={portList} 
                                  id="fd" 
                                  name="fd" 
                                  onChange={(e) => [
                                                    setSelectedFd(e),
                                                    getIhcImportRoute(selectedPod, e)
                                                  ]}
                                  value={selectedFd}
                                  isMulti={false}
                                  isClearable
                                  className="px-0"
                                  placeholder={<span>FD <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 px-0 font-12px mt-2">Vessel Schedule</div>
                              <div className="col-12 px-0">
                                <Select 
                                  options={vesselScheduleList} 
                                  id="vessel_schedule" 
                                  name="vessel_schedule" 
                                  onChange={(e) => [setSelectedVesselSchedule(e), setSelectedPolTerminal(e?.terminal)]}
                                  value={selectedVesselSchedule}
                                  isMulti={false}
                                  isClearable
                                  className="px-0"
                                  placeholder={<span>Vessel Schedule <span style={{ color: 'red' }}>*</span></span>}
                                  styles={customRouteValidationStyles}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div class="d-flex text-center my-1 px-0">
                                <button type="button" 
                                        className="btn btn-secondary border-0 w-100" 
                                        style={{ marginRight: 5 }} onClick={() => [
                                                                                  setRouteFormOpen(false), 
                                                                                  setShowRouteError(false),
                                                                                  setSelectedPoa(""),
                                                                                  setSelectedPol(""),
                                                                                  setSelectedPolTerminal(""),
                                                                                  setSelectedPod(""),
                                                                                  setSelectedFd("")
                                                                                  ]}>Cancel</button>
                                <button className="btn btn-inox-green border-0 w-100 text-white" style={{ marginLeft: 5 }} onClick={() => setRouteFormOpen(false)}>Save</button>
                              </div>
                            </div>
                          </form>
                        </div>
                    </div>
                  )}
                </div>

                <div class="p-2 flex-grow-1">
                  <h5 className="fw-bold">Cargo and Container</h5>
                  <input 
                    ref={triggerCargoFormRef} 
                    type="text" 
                    className="form-control form-control-sm border-0" 
                    placeholder="What is being shipped?" 
                    onClick={handleCargoFormClick}
                  />

                  {/* ------------------ Cargo and Container Details ------------------- */}
                  {cargoRows[0].container_size != "" && cargoRows[0].cargo_type != "" && cargoRows[0].commodity != "" && cargoRows.map((cargo, index) => (
                  <div style={{ fontSize: 13 }} class={`${cargoRows[index]['export_transport_charge']==""?"display-none":" pt-3"}`}>
                    <hr className={`${index==0?"display-none":"my-1"}`}></hr>
                    <small>
                      <Image src={cargo.container_size.type == "TANK"?IsoTankImage:ContainerImage} height={30} className="mr-2 mb-1"></Image>
                      {cargo.quantity} x {cargo.container_size.label} {cargo.commodity} ({cargo.cargo_type == "NON_HAZARDOUS"?"NON-HAZ":"HAZ"})
                    </small><br></br>
                    <small>
                      <span><b>Weight: </b>{cargo.quantity * cargo.weight} MT</span>
                      <span className="ml-3"><b>IHC: </b>
                        {icdImportCurrency?.country == "India" || icdExportCurrency?.symbol == "India"?
                          selectedPoa.type == "DRYPORT"?
                            FormatCurrency(cargo.export_transport_charge + cargo.export_iso_tank_charge + cargo.export_dg_surcharge + cargo.export_bss_surcharge, "INR", "en-IN")
                          :
                          selectedFd.type == "DRYPORT"?
                            FormatCurrency(cargo.import_transport_charge + cargo.import_iso_tank_charge + cargo.import_dg_surcharge + cargo.import_bss_surcharge, "INR", "en-IN")
                          :
                          0
                        :
                          selectedPoa.type == "DRYPORT"?
                            FormatCurrency(cargo.export_transport_charge + cargo.export_iso_tank_charge + cargo.export_dg_surcharge + cargo.export_bss_surcharge, "USD")
                          :
                          selectedFd.type == "DRYPORT"?
                            FormatCurrency(cargo.import_transport_charge + cargo.import_iso_tank_charge + cargo.import_dg_surcharge + cargo.import_bss_surcharge, "USD")
                          :
                          0
                          
                        }
                        <small> (Inc. Taxes)</small>
                      </span>
                    </small>
                  </div>
                ))}

                {cargoRows && cargoRows?.[0]?.export_transport_charge > 0?
                <div style={{ fontSize: 12 }}>
                  <hr className="my-1"></hr>
                  <span><b>Total Containers: </b>{cargoRows?.reduce((sum, row) => sum + parseInt(row.quantity), 0)}</span><br></br>
                  <span>
                    <b>Total Weight: </b>
                    {cargoRows.reduce((sum, row) => sum + Number(row.quantity * row.weight || 0), 0)} + {(cargoRows.reduce((sum, row) => sum + Number(row.quantity * row.tare_weight || 0), 0)).toFixed(2)} (Tare Weight) = {cargoRows.reduce((sum, row) => sum + Number(row.quantity * row.weight || 0), 0) + cargoRows.reduce((sum, row) => sum + Number(row.quantity * row.tare_weight || 0), 0)} MT
                  </span><br></br>
                  
                  {selectedPoa.type == "DRYPORT"?
                  <div className="row">
                    <div className="col-8">
                      {icdExportCurrency?.country != "India"?
                        <span style={{ verticalAlign: '-webkit-baseline-middle'}}>                  
                          <b>Total IHC Export Charge: </b>
                            {FormatCurrency(((cargoRows.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                            ) * parseFloat(icdExportCurrency?.currency_value)).toFixed(2), "USD")}
                        </span>
                      :
                        <span style={{ verticalAlign: '-webkit-baseline-middle'}}>                  
                          <b>Total IHC Export Charge: </b>
                            {FormatCurrency((cargoRows.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                            ).toFixed(2), "INR", "en-IN")}
                        </span>
                      }
                    </div>
                  </div>
                  :""}

                  {selectedFd.type == "DRYPORT"?
                  <div className="row">
                    <div className="col-8">
                      {icdImportCurrency?.country != "India"?
                        <span style={{ verticalAlign: '-webkit-baseline-middle'}}>                  
                          <b>Total IHC Import Charge: </b>
                            {FormatCurrency(((cargoRows.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                            ) * parseFloat(icdImportCurrency?.currency_value)).toFixed(2), "USD")}
                        </span>
                      :
                        <span style={{ verticalAlign: '-webkit-baseline-middle'}}>                  
                          <b>Total IHC Import Charge: </b>
                            {FormatCurrency((cargoRows.reduce((sum, row) => sum + Number(row.export_transport_charge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_iso_tank_charge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_dg_surcharge || 0), 0) +
                            cargoRows.reduce((sum, row) => sum + Number(row.export_bss_surcharge || 0), 0)
                            ).toFixed(2), "INR", "en-IN")}
                        </span>
                      }
                    </div>
                  </div>
                  :""}
                </div>
                :""}

                  {cargoFormOpen && (
                    <div
                      ref={tooltipCargoFormRef}
                      className="tooltip-form-line-item-container"
                      style={{
                        top: tooltipPosition.top,
                        left: tooltipPosition.left,
                        transform: "translateX(-60%)",
                      }}
                    >
                      <div className="tooltip-arrow" />
                        <div className="tooltip-content px-3" style={{background: '#FFF' }}>
                          {bookingLineItemLoader?
                          <div className="d-flex flex-column align-items-center justify-content-center mt-4 mb-5">
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          </div>
                          :""
                          }

                          {selectedPol && selectedFd && cargoRows.map((row, index) => (
                          <form className={`tooltip-form ${index!=0?'mt-2':''}`}>
                            <div className="row">
                              <div class="col-2 px-0">
                                <Select 
                                  options={containerSizeList}
                                  id={"container_size" + index} 
                                  name={"container_size" + index}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "container_size", e),
                                                    getIhcExportCharge(cargoRows[index], index),
                                                    getIhcImportCharge(cargoRows[index], index)
                                                  ]}
                                  isMulti={false}
                                  isClearable
                                  className="px-0"
                                  placeholder={cargoRows[index]['container_size']? cargoRows[index]['container_size']['label']:"Container Size"}
                                />
                              </div>

                              <div class="col-2 px-0">
                                <input 
                                  id={"quantity" + index} 
                                  name={"quantity" + index}
                                  type="number"
                                  placeholder={cargoRows[index]['quantity']? cargoRows[index]['quantity']:"Quantity"}
                                  className="ml-1"
                                  style={{ height: '39px' }}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "quantity", e.target.value),
                                                    getIhcExportCharge(cargoRows[index], index),
                                                    getIhcImportCharge(cargoRows[index], index)
                                                  ]}>
                                </input>
                              </div>

                              <div class="col-2 px-0">
                                <Select 
                                  options={cargoTypeList}
                                  id={"cargo_type" + index} 
                                  name={"cargo_type" + index}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "cargo_type", e?.value),
                                                    getIhcExportCharge(cargoRows[index], index),
                                                    getIhcImportCharge(cargoRows[index], index)
                                                  ]}
                                  isMulti={false}
                                  isClearable
                                  className="px-0 ml-1"
                                  placeholder={cargoRows[index]['cargo_type']? cargoRows[index]['cargo_type']:"Cargo Type"}
                                />
                              </div>

                              <div class="col-3 px-0">
                                <Select 
                                  options={commodityList.filter(item => item.type === cargoRows[index]['cargo_type'])}
                                  id={"commodity" + index} 
                                  name={"commodity" + index}
                                  onChange={(e) => [
                                                    handleChange(index, row.id, "commodity", e.value),
                                                    getIhcExportCharge(cargoRows[index], index),
                                                    getIhcImportCharge(cargoRows[index], index)
                                                  ]}
                  
                                  isMulti={false}
                                  isClearable
                                  className="px-0 ml-1"
                                  placeholder={cargoRows[index]['commodity']? cargoRows[index]['commodity']:"Commodity"}
                                />
                              </div>

                              <div class="col-1 px-0">
                                <input 
                                  id={"weight" + index} 
                                  name={"weight" + index}
                                  type="number"
                                  placeholder={cargoRows[index]['weight']? cargoRows[index]['weight']:"Weight (KG)"}
                                  className="ml-1"
                                  style={{ height: '39px' }}
                                  onChange={(e) => {
                                    if(e.target.value>30){
                                        toast.error("Maximum 30 MT weight is allowed")
                                    }
                                    else{
                                        handleChange(index, row.id, "weight", e.target.value)
                                        getIhcExportCharge(cargoRows[index], index)
                                        getIhcImportCharge(cargoRows[index], index)
                                    }
                                  }}>
                                </input>
                              </div>
                              
                              <div class="col-2 px-0">
                                <Button 
                                  className="btn btn-sm btn-inox-green ml-1 border-0"
                                  style={{ width: '50px', height: '39px', float: 'right' }}
                                  title="Add Cargo"
                                  onClick={() => addRow()}>
                                    <i className="fa fa-plus"></i>
                                </Button>

                                <Button 
                                  className="btn btn-sm btn-inox-red ml-1 border-0"
                                  style={{ width: '50px', height: '39px', float: 'right' }}
                                  title="Remove Cargo"
                                  onClick={() => removeRow(row.id)}
                                  disabled={index == 0 ? true : false}>
                                    <i className="fa fa-trash"></i>
                                </Button>
                              </div>
                            </div>
                          </form>
                          ))}
                          
                          {selectedPol && selectedFd?
                          <div className="row mt-3">
                            <div class="d-flex justify-content-center text-center my-1 px-0">
                              <button type="button" 
                                      className="btn btn-secondary border-0" 
                                      style={{ marginRight: 5, width: 200 }} 
                                      onClick={() => [
                                                      setCargoFormOpen(false),
                                                      setCargoRows([{
                                                        id: generateId,
                                                        container_size: "",
                                                        quantity: 1,
                                                        weight: 0,
                                                        tare_weight: 0,
                                                        slot: 0,
                                                        export_iso_tank_charge: 0,
                                                        export_dg_surcharge: 0,
                                                        export_bss_surcharge: 0,
                                                        export_transport_charge: 0,
                                                        export_iso_tank_charge_expense: 0,
                                                        export_dg_surcharge_expense: 0,
                                                        export_bss_surcharge_expense: 0,
                                                        export_transport_charge_expense: 0,
                                                        import_iso_tank_charge: 0,
                                                        import_dg_surcharge: 0,
                                                        import_bss_surcharge: 0,
                                                        import_transport_charge: 0,
                                                        import_iso_tank_charge_expense: 0,
                                                        import_dg_surcharge_expense: 0,
                                                        import_bss_surcharge_expense: 0,
                                                        import_transport_charge_expense: 0,
                                                        cargo_type: "",
                                                        commodity: "",
                                                        currency: ""
                                                      }])
                                                    ]}>Cancel</button>

                              <button className="btn btn-inox-green border-0 text-white" style={{ marginLeft: 5, width: 200 }} onClick={() => setCargoFormOpen(false)}>Save</button>
                            </div>
                          </div>
                          :
                          <p className="text-center py-5">Select <b>Source</b> and <b>Destination</b> Before Adding Cargo and Container</p>
                          }
                        </div>
                    </div>
                  )}
                </div>

                <div class="p-2">
                  <Button className="btn btn-inox-green btn-sm border-0" style={{ marginTop: 30 }} onClick={() => getTariffCharges()}
                    disabled={enableSearchButton?false:true}>
                      {tarrifChargeDataPending?
                        <Spinner size="sm"></Spinner>
                      :
                        <i className="fa fa-search"></i>
                      }
                    
                  </Button>
                </div>
              </div>
            </div>

            <div class="col-12 mt-3 px-0" style={{ marginLeft: 18 }}>
              <textarea class="form-control" 
                        onChange={(e) => setRemarks(e.target.value)} 
                        value={remarks}
                        rows="3" 
                        placeholder="Add remarks or specific request for the quote">        
              </textarea>
            </div>

            <div class="col-12 mt-3 mb-5 px-0" style={{ marginLeft: 18 }}>
              <div className="flex-grow-1">
                <Accordion defaultActiveKey={['0']} alwaysOpen>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header width={1000}>
                      <div class="d-flex justify-content-end">
                        <span>Local Charges</span>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="row">
                        <div className="col-6">
                          <div className="row mb-3">
                            <div className="col-6">
                              <h5>Approximate Export Local Charges</h5>
                            </div>
                          </div>

                          <DataTable
                            columns={localchargescolumns}
                            data={exportLocal.filter(item => item.amount != 0)}
                            progressPending={tarrifChargeDataPending}
                            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
                            noDataComponent={<p className="text-center py-5">No Export Charges Found</p>}
                            pagination
                            highlightOnHover
                            fixedHeader
                            dense
                            customStyles={importExportTableCustomStyles}
                          />
                        </div>

                        <div className="col-6">
                          <div className="row mb-3">
                            <div className="col-6">
                              <h5>Approximate Import Local Charges</h5>
                            </div>
                          </div>

                          <DataTable
                            columns={localchargescolumns}
                            data={importLocal.filter(item => item.amount != 0)}
                            progressPending={tarrifChargeDataPending}
                            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
                            noDataComponent={<p className="text-center py-5">No Import Charges Found</p>}
                            pagination
                            highlightOnHover
                            fixedHeader
                            dense
                            customStyles={importExportTableCustomStyles}
                          />
                        </div>
                        
                        <div className="col-6">
                          <h5>Total Export Charges (Approximate):
                            <b> $ {totalExportCharge.toFixed(2)}</b>
                          </h5>
                        </div>

                        <div className="col-6">
                          <h5>Total Import Charges (Approximate): 
                            <b> $ {totalImportCharge.toFixed(2)}</b>
                          </h5>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>

            <div className="col-12 mb-4">
              <div className="row">
                <div className="col-7">
                  <div className="btn-group dropup float-right">
                    <button type="button" className="btn btn-inox-green border-0 text-white" onClick={() => setShowRequestModal(true)}
                      disabled={totalImportCharge == 0 && totalImportCharge == 0?true:false}>
                      <span className="px-3">Send Request</span>
                    </button>
                  </div>
                </div>
              </div>

              <Modal size="md" show={showRequestModal} onHide={() => setShowRequestModal(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Send Request </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p className="font-12px text-danger">Our team will be contacting you shortly using the information provided.</p>
                  <form ref={requestFormRef}>
                    <div className="row">
                      <div class="col-12 mb-3">
                        <div class="form-group mb-2">
                          <label for="name" class="col-sm-12 col-form-label">Company Name</label>
                          <div class="col-sm-12">
                            <input type="text" class="form form-control form-control-sm" id="name" name="name" onChange={(e) => setRequestName(e.target.value)}/>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mb-3">
                        <div class="form-group mb-2">
                          <label for="name" class="col-sm-12 col-form-label">Company Email</label>
                          <div class="col-sm-12">
                            <input type="email" class="form form-control form-control-sm" id="email" name="email" onChange={(e) => setRequestEmail(e.target.value)}/>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mb-3">
                        <div class="form-group mb-2">
                          <label for="name" class="col-sm-12 col-form-label">Contact Number</label>
                          <div class="col-sm-12">
                            <input type="number" class="form form-control form-control-sm" id="contact" name="contact" onChange={(e) => setRequestContact(e.target.value)}/>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 d-flex justify-content-center">
                        <button type="button" className="btn btn-inox-green border-0 text-white my-3" onClick={(e) => addNewRequest(e)}
                          disabled={totalImportCharge == 0 && totalImportCharge == 0?true:false}>
                          <span className="px-3">Send Request</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quote;